import instance from 'api';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IDelayReasonClient } from './interfaces';

export const getDelayReasonClientList = (data: IDynamicTableParams) => {
  return instance()
    .post<IDelayReasonClient[]>('/delayReasonClient/list', data)
    .then((response) => response.data);
};

export const getDelayReasonClientListAll = () => {
  return instance()
    .post<IDelayReasonClient[]>('/delayReasonClient/listAll')
    .then((response) => response.data);
};

export const getChecklistAfterGroupListAllNotDeleted = () => {
  return instance()
    .get<IDelayReasonClient[]>('/delayReasonClient/listAllNotDeleted')
    .then((response) => response.data);
};

export const getDelayReasonClientAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/delayReasonClient/availableColumns')
    .then((response) => response.data);
};

export const getDelayReasonClientAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/delayReasonClient/availableGroupColumns')
    .then((response) => response.data);
};

export const loadDelayReasonClient = (delayReasonClientId: number) => {
  return instance()
    .get<IDelayReasonClient>(`/delayReasonClient/load/${delayReasonClientId}`)
    .then((response) => response.data);
};

export const createDelayReasonClient = (delayReasonClient: IDelayReasonClient) => {
  return instance()
    .post<IDelayReasonClient>(`/delayReasonClient/save`, delayReasonClient)
    .then((response) => response.data);
};

export const updateDelayReasonClient = (delayReasonClient: IDelayReasonClient) => {
  return instance()
    .post<IDelayReasonClient>(`/delayReasonClient/${delayReasonClient.delayReasonClientId}/update`, delayReasonClient)
    .then((response) => response.data);
};

export const archiveDelayReasonClient = (delayReasonClientId: number) => {
  return instance()
    .post(`/delayReasonClient/archive`, { delayReasonClientId })
    .then((response) => response.data);
};

export const recoverDelayReasonClient = (delayReasonClientId: number) => {
  return instance()
    .post(`/delayReasonClient/recover`, { delayReasonClientId })
    .then((response) => response.data);
};
